
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFoundState = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="flex justify-between items-center mb-8">
        <Button variant="ghost" onClick={handleGoBack} size="sm" className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back
        </Button>
      </div>
      <div className="flex justify-center items-center h-64">
        <div className="text-center">
          <h2 className="text-xl font-medium mb-2">Profile not found</h2>
          <p className="text-muted-foreground mb-4">There was an issue loading your profile.</p>
          <Button onClick={() => navigate("/")}>Return Home</Button>
        </div>
      </div>
    </>
  );
};

export default NotFoundState;
